// extracted by mini-css-extract-plugin
export var blockVerticalAdapt = "style-module--block-vertical-adapt--0dc9a";
export var block__lessonAmount = "style-module--block__lesson-amount--88afe";
export var block__lessonDuration = "style-module--block__lesson-duration--513fe";
export var block__num = "style-module--block__num--efcee";
export var structure = "style-module--structure--19b55";
export var structure__blockBtnWrapper = "style-module--structure__block-btn-wrapper--07f78";
export var structure__blockHeaderRow = "style-module--structure__block-header-row--ad52d";
export var structure__blockHeaderTitle = "style-module--structure__block-header-title--718ee";
export var structure__blockResult = "style-module--structure__block-result--d90ca";
export var structure__blockTotal = "style-module--structure__block-total--103a1";
export var structure__blocks = "style-module--structure__blocks--0edb4";
export var structure__blocksTitle = "style-module--structure__blocks-title--1742d";
export var structure__title = "style-module--structure__title--efed7";
export var structure__wrapper = "style-module--structure__wrapper--bccad";